import { render, staticRenderFns } from "./LgpdIdentityVerification.vue?vue&type=template&id=0e30abb9&scoped=true&"
import script from "./LgpdIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./LgpdIdentityVerification.vue?vue&type=script&lang=js&"
import style0 from "./LgpdIdentityVerification.vue?vue&type=style&index=0&id=0e30abb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e30abb9",
  null
  
)

export default component.exports